<template>
  <div class="alert-container">
    <v-slide-x-transition>
      <div
        v-if="open"
        :type="type"
        class="alert white--text layout align-center dark px-3 elevation-4"
        :style="`background-color: var(${backgroundColor()});`"
      >
        <div class="mr-2 bold">
          {{ message }}
        </div>
        <v-spacer />
        <v-btn dark icon small @click.stop="dismiss">
          <v-icon>
            {{ icons.close }}
          </v-icon>
        </v-btn>
      </div>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { ALERT_CLOSE } from '@/config/constants';
import { setTimeout } from 'timers';
import icons from '../../mixins/icons';

export default {
  name: 'Alert',
  mixins: [icons],
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'warning'
    },
    dismissInMs: {
      type: Number,
      default: 5000
    },
    dismissAuto: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    error: {
      get() {
        return this.open;
      },
      set() {
        return (this.open = !this.open);
      }
    },
    open: {
      get() {
        return this.$store.state.alerts.open;
      },
      set(e) {
        return this.$store.commit(ALERT_CLOSE);
      }
    }
  },
  watch: {
    open: function(i) {
      if (i) {
        this.autoDismiss();
      }
    },
    error: {
      handler: function() {
        this.autoDismiss();
      }
    }
  },
  created() {
    this.autoDismiss();
  },
  methods: {
    backgroundColor() {
      switch (this.type) {
        case 'warning':
          return '--approval';
        case 'success':
          return '--done';

        default:
          return '--red';
      }
    },
    dismiss: function() {
      this.open = false;
    },
    autoDismiss: function() {
      if (this.error === true && this.dismissAuto) {
        setTimeout(
          function() {
            return (this.open = false);
          }.bind(this),
          this.dismissInMs
        );
      }
    }
  }
};
</script>

<style scoped>
.alert {
  z-index: 100000;
  position: fixed;
  border-radius: 3px;
  font-weight: bold;
  align-self: center;
  justify-self: center;
  bottom: 20px;
  left: 20px;
  color: black;
}
</style>
